<template>
  <hm-content title="服务卡列表">
    <div slot="header">
      <hm-step :steps="steps" :step="3"></hm-step>
    </div>
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" plain size="small" @click="toAddProduct"
          >新增服务卡</el-button
        >
      </div>
      <div>
        <el-select
          clearable
          v-model="storeOutletId"
          placeholder="选择门店"
          size="small"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部门店"
                     :value="0"></el-option> -->
          <el-option
            v-for="item in storeList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          :disabled="!storeOutletId"
          v-model="categoryId"
          placeholder="选择商品分类"
          size="small"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部门店"
                     :value="0"></el-option> -->
          <el-option
            v-for="item in categoryList.list"
            :key="item.id"
            :label="item.categoryName"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="serverId"
          placeholder="选择服务"
          size="small"
          filterable
          class="mr10"
        >
          <el-option
            v-for="item in serviceList.list"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          clearable
          v-model="status"
          placeholder="选择服务卡状态"
          size="small"
          filterable
          class="mr10"
        >
          <el-option label="开启" :value="1"></el-option>
          <el-option label="关闭" :value="0"></el-option>
        </el-select>
        <el-input
          clearable
          v-model.trim="productName"
          placeholder="输入服务卡名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button
          type="primary"
          size="small"
          @click="search"
          clearable
          placeholder="输入名称"
          >查询</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        :data="productList.list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column type="index" width="50" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="productName"
          label="服务卡名称"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="price"
          label="服务卡价格(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberPrice"
          label="会员价格(元)"
        >
        </el-table-column>
        <!-- <el-table-column header-align="center"
                         align="center"
                         label="服务卡标签">
          <template slot-scope="scope">
            <span class="tag"
                  v-for="(v, i) in scope.row.productTags"
                  :key="i">
              {{v}}
            </span>
          </template>
        </el-table-column> -->
        <!-- <el-table-column header-align="center"
                         align="center"
                         prop="specification"
                         label="服务卡规格"></el-table-column> -->
        <el-table-column header-align="center" align="center" label="有效期">
          <template slot-scope="scope">
            <span v-if="scope.row.validType === 0">不限时间</span>
            <span v-else-if="scope.row.validType === 2"
              >{{ scope.row.validStartDateFormat }}至{{
                scope.row.validEndDateFormat
              }}</span
            >
            <span v-else-if="scope.row.validType === 1"
              >购买{{ scope.row.validSpaceDay }}天后生效，有效期{{
                scope.row.validDay
              }}天</span
            >
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="relatedName"
          label="商品列表"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeOutlet"
          label="所属门店"
        >
          <!-- <template slot-scope="scope">
            {{scope.row.storeOutletId ? scope.row.storeOutlet : '全部门店'}}
          </template> -->
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="serverName"
          label="所属服务"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="所属分类"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="服务卡状态"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.status === 0 ? "关闭" : "开启" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="首页推荐"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.recommendStatus === 0 ? "不推荐" : "推荐"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row.id)"
              >编辑</el-button
            >
            <el-button type="text" size="small" @click="remove(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="productList.total"
        @current-change="paging"
        layout="total,sizes,   prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-content>
</template>

<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";

export default {
  components: { HmStep },
  data() {
    return {
      steps: [
        {
          link: "ProductCategory",
          name: "商品分类列表"
        },
        {
          link: "CommodityList",
          name: "商品列表"
        },
        {
          link: "ProductList",
          name: "服务卡列表"
        }
      ],
      storeOutletId: "",
      categoryId: "",
      serverId: "",
      pageSize: 10,
      status: "",
      currentPage: 1,
      productName: ""
    };
  },
  computed: mapGetters([
    "productList",
    "storeList",
    "categoryList",
    "serviceList"
  ]),
  mounted() {
    this.queryList();
    this.$store.dispatch("queryStoreList", { pageSize: 999 });
    this.$store.dispatch("queryServiceList", { pageSize: 999 });
  },
  watch: {
    storeOutletId(storeOutletId) {
      if (storeOutletId) {
        this.$store.dispatch("queryCategoryList", {
          pageSize: 999,
          isShow: 1,
          storeOutletId
        });
      }
    }
  },
  methods: {
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    queryList() {
      this.$store.dispatch("queryProductList", {
        productName: this.productName,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        categoryId: this.categoryId,
        serverId: this.serverId,
        status: this.status
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    toAddProduct() {
      this.$router.push({ name: "AddProductList" });
    },
    edit(id) {
      this.$router.push({
        name: "EditProductList",
        query: {
          id: String(id)
        }
      });
    },
    remove(id) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("deleteProduct", {
            id
          })
          .then(res => {
            if (res.code === "0") {
              this.$message({
                message: "删除服务卡成功",
                type: "success"
              });
              this.queryList();
            }
          });
      });
    }
  }
};
</script>

<style scoped lang="scss">
.tag {
  background-color: #fce6f0;
  padding: 2px 4px;
  margin-right: 5px;
  border-radius: 3px;
  color: #666;
  word-break: keep-all;
}
</style>
